import { MakeCall } from './createMakeCall';

export enum PersonalReasons {
  TravelRestrictions = 'travelRestrictions',
  VisaRejected = 'visaRejected',
  PlansChanged = 'plansChanged',
  FoundNewAccommodationHA = 'foundNewAccommodationHA',
  FoundNewAccommodationOther = 'foundNewAccommodationOther',
  NeighborhoodNotSuitable = 'neighborhoodNotSuitable',
  RoommateProblems = 'roommateProblems',
  ChangedMind = 'changedMind',
  Other = 'other',
}

export enum ListingNotAsAdvertised {
  PropertyDifferentInSize = 'propertyDifferentInSize',
  PropertyLocationDifferent = 'propertyLocationDifferent',
  PropertyDamaged = 'propertyDamaged',
  PropertyDirty = 'propertyDirty',
  PropertyNoPrivacy = 'propertyNoPrivacy',
  PropertyNotAvailable = 'propertyNotAvailable',
  FurnitureMissing = 'furnitureMissing',
  Other = 'other',
}

export enum AdvertiserBehavior {
  CommunicationIssuesGeneral = 'communicationIssuesGeneral',
  ContractsUnclear = 'contractsUnclear',
  AdditionalPayments = 'additionalPayments',
  BehaviorDistrusting = 'behaviorDistrusting',
  NotAllowedToMoveIn = 'notAllowedToMoveIn',
  RentDifferentSize = 'rentDifferentSize',
  Other = 'other',
}

export interface BookingCancellationReasons {
  personalReasons: PersonalReasons[];
  listingNotAsAdvertised: ListingNotAsAdvertised[];
  advertiserBehavior: AdvertiserBehavior[];
}

export interface Payload {
  message: string;
  attachments: string[];
  cancellationReasons: BookingCancellationReasons;
}

const cancelBooking =
  (makeCall: MakeCall) => (conversationId: number, data: Payload) =>
    makeCall('POST', `/api/v2/conversation/${conversationId}/booking-cancel`, {
      data,
    });

export { cancelBooking };
